module.exports = __webpack_public_path__ + "static/cosi3s-4d7f4d91e3dd4e52c8437a836702faa5.jpg";